<ticker-card
  [titleText]="'crmContacts.analytics.revenueTotal' | translate"
  [data]="data"
  [percentage]="-14.7"
  icon="dataarea"
></ticker-card>
